import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=5f1d5cea&"
import script from "./ChatMessage.vue?vue&type=script&lang=ts&"
export * from "./ChatMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports